import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import {
  BlankValidator,
  CPFValidator,
  DateValidator,
  MaskManager,
  NbpConfirmComponent,
  UtilHelper,
  ValidationResult,
  NbpInfoComponent,
} from '../../../shared/';
import { EnderecoModel } from '../../../shared/endereco/';
import { EnderecoService } from '../../../shared/endereco/endereco.service';
import { NgbdModalContent } from '../../../shared/modal/ngbd-modal-content';
import { EmailValidator } from '../../../shared/validators/emailPattern.validator';
import { ConsumidorFormatter, ConsumidorModel, ConsumidorService } from '../shared/';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { AnimacaoHelper } from '../../../shared/helpers/animacao-helper';
import * as moment from 'moment';
import { TipoResponsabilidadeRepresentanteLegalModel } from '../../../shared/model/tipo-responsabilidade-representante-legal.model';
import { TipoResponsabilidadeRepresentanteLegalService } from '../../../shared/service/tipo-responsabilidade-representante-legal.service';
import { RepresentanteLegalModel } from '../../representanteLegal/shared/representante-legal.model';
import { LinkResourcesService } from '../shared/link-resources-service';
import { debounceTime } from 'rxjs/operators';
import { ConsumidorReceitaFederalService } from '../shared/consumidor-receita-federal-service';
import { FiltroConsumidorReceitaFederal } from '../../../shared/filter/filtro-consumidor-receita-federal';

interface IValidation {
  [key: string]: boolean;
}

@Component({
  selector: 'app-consumidor-edit',
  templateUrl: './consumidor-edit.component.html',
  styleUrls: []
})
export class ConsumidorEditComponent implements OnInit, OnDestroy {
  public msgErroRepresentanteLegal = '';
  public consumidor: ConsumidorModel;
  public subsConsumidor: Subscription;
  public subsError: Subscription;
  public subsCep: Subscription;
  public subscriptionEnderecoModelSelecionado: Subscription;
  public cpf = '';
  public consumidorForm: FormGroup;
  public maskCPF = MaskManager.CPF;
  public maskCEP = MaskManager.CEP;
  public maskDDD = MaskManager.DDD;
  public maskTelefone = MaskManager.tel;
  public maskData = MaskManager.DATA;
  public contador;

  public msgErro : string;

  public btnConcluirDisabled = true;
  public mostrarAlertaParticipacao =  false;

  public showRepresentanteLegal = false;

  public subsCepRepresentanteLegal: Subscription;
  public unsubTiposResponsabilidadesRepresentanteLegalChange: Subscription;
  public tiposResponsabilidadesRepresentanteLegal: TipoResponsabilidadeRepresentanteLegalModel[];
  public tipoResponsabilidadeRepresentanteLegalChange: Subscription;

  public formErrors = {
    nome: [],
    cpf: [],
    dataNascimento: [],
    nomeMae: [],
    cep: [],
    dddTelefone: [],
    telefone: [],
    celular: [],
    'emailGroup.emailPrincipal': [],
    'emailGroup.confirmEmailPrincipal': [],
    'senhaGroup.senha': [],
    'senhaGroup.senhaConfirm': [],
    fraseSeguranca: [],
    sigUnidFederacao: [],
    logradouro: [],
    cidade: [],
    errosSelecao: [],
    emailOpcional: [],
    emailGroup: [],
    numeroEndereco: [],
    emailPrincipalRepresentanteLegal: [],
    confirmEmailPrincipalRepresentanteLegal: [],

    // Representante Legal
    cpfRepresentanteLegal: [],
    nomeRepresentanteLegal: [],
    nomeMaeRepresentanteLegal: [],
    dataNascimentoRepresentanteLegal: [],
    cepRepresentanteLegal: [],
    dddTelefoneRepresentanteLegal: [],
    telefoneRepresentanteLegal: [],
    celularRepresentanteLegal: [],
    sigUnidFederacaoRepresentanteLegal: [],
    logradouroRepresentanteLegal: [],
    cidadeRepresentanteLegal: [],
    errosSelecaoRepresentanteLegal: [],
    emailOpcionalRepresentanteLegal: [],
    emailGroupRepresentanteLegal: [],
    'emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal': [],
    'emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal': [],
    numeroEnderecoRepresentanteLegal: [],
    tipoResponsabilidadeRepresentanteLegal: [],

  };

  public validationMessages = {
    nome: {
      required: 'O Campo Nome é de preenchimento obrigatório.'
    },
    numeroEndereco: {
      required: 'O Campo Número do Endereço é de preenchimento obrigatório.'
    },
    cpf: {
      required: 'O Campo CPF é de preenchimento obrigatório.',
      cpfInvalido: 'Informe um CPF válido.'
    },
    dataNascimento: {
      brazilianDate: 'Data de Nascimento inválida. Informe uma Data de Nascimento válida.',
      dataInvalida: 'O Campo Data de Nascimento não pode ser maior que a data atual.',
      dataIgualAtual: 'O Campo Data de Nascimento não pode ser igual a data atual.'
    },
    nomeMae: {
      required: 'O Campo Nome da Mãe é de preenchimento obrigatório.'
    },
    cep: {
      required: 'O Campo CEP é de preenchimento obrigatório.',
      pattern: 'CEP inválido. Informe um CEP válido.'
    },
    dddTelefone: {
      required: 'O Campo DDD é de preenchimento obrigatório.'
    },
    telefone: {
      required: 'O Campo Tel. Contato é de preenchimento obrigatório.',
      pattern: 'Tel. Contato inválido. Informe um Tel. Contato válido.'
    },
    celular: {
      pattern: 'Tel. Opcional inválido. Informe um Tel. Opcional válido.',
      celularObrigatorio: 'DDD opcional informado Tel. Opcional obrigatório.',
      dddCelularObrigatorio: 'Tel. Opcional informado DDD Opcional obrigatório.'
    },
    emailOpcional: {
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroup.emailPrincipal': {
      required: 'O Campo E-mail Principal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroup.confirmEmailPrincipal': {
      required: 'O Campo Confirmar E-mail Principal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },

    fraseSeguranca: {
      required: 'O Campo Frase de Segurança é de preenchimento obrigatório.'
    },
    sigUnidFederacao: {
      required: 'O Campo UF é de preenchimento obrigatório.'
    },
    logradouro: {
      required: 'O Campo Endereço é de preenchimento obrigatório.'
    },
    cidade: {
      required: 'O Campo Município é de preenchimento obrigatório.'
    },
    emailGroup: {
      emailNaoConfirmado: UtilHelper.MsgGenericas.email_NaoConfirmado
    },
    emailGroupInvalid: UtilHelper.MsgGenericas.email_NaoConfirmado
    ,
    // Representante Legal
    emailGroupRepresentanteLegal: {
      emailNaoConfirmado: UtilHelper.MsgGenericas.email_NaoConfirmado
    },

    emailGroupRepresentanteLegalInvalid: UtilHelper.MsgGenericas.email_NaoConfirmado,


    cpfRepresentanteLegal: {
      required: 'O Campo CPF do Representante Legal é de preenchimento obrigatório.',
      cpfInvalido: 'Informe um CPF válido para o Representante Legal.',
      mesmoCpfConsumidor: 'O CPF do Representante Legal deve ser diferente do Consumidor.'
    },

    dataNascimentoRepresentanteLegal: {
      required: 'O Campo Data de Nascimento do Representante Legal é de preenchimento obrigatório.',
      pattern: 'Informe uma Data de Nascimento válida para o Representante Legal.',
      brazilianDate: 'Data de Nascimento inválida. Informe uma Data de Nascimento válida.',
      dataInvalida: 'O Campo Data de Nascimento não pode ser maior que a data atual',
      dataIgualAtual: 'O Campo Data de Nascimento não pode ser igual a data atual.',
      menorDeIdade: 'O Representante Legal deve posuir mais de 18 anos'
    },

    nomeRepresentanteLegal: {
      required: 'O Campo Nome do Representante Legal é de preenchimento obrigatório.'
    },

    nomeMaeRepresentanteLegal: {
      required: 'O Campo Nome da Mãe do Representante Legal é de preenchimento obrigatório.'
    },

    numeroEnderecoRepresentanteLegal: {
      required: 'O Campo Número do Endereço do Representante Legal é de preenchimento obrigatório.'
    },

    cepRepresentanteLegal: {
      required: 'O Campo CEP do Representante Legal é de preenchimento obrigatório.',
      pattern: 'CEP inválido. Informe um CEP válido.'
    },

    dddTelefoneRepresentanteLegal: {
      required: 'O Campo DDD do Representante Legal é de preenchimento obrigatório.'
    },

    telefoneRepresentanteLegal: {
      required: 'O Campo Tel. Contato do Representante Legal é de preenchimento obrigatório.',
      pattern: 'Tel. Contato do Representante Legal é inválido.'
    },

    celularRepresentanteLegal: {
      pattern: 'Celular do Representante Legal inválido. Informe um Celular.',
      celularObrigatorio: 'Telefone deve ser preenchido quando o DDD for informado.',
      dddCelularObrigatorio: 'DDD deve ser preenchido quando o Telefone for informado.'
    },

    sigUnidFederacaoRepresentanteLegal: {
      required: 'O Campo UF do Representante Legal é de preenchimento obrigatório.'
    },

    logradouroRepresentanteLegal: {
      required: 'O Campo Endereço do Representante Legal é de preenchimento obrigatório.'
    },

    cidadeRepresentanteLegal: {
      required: 'O Campo Município do Representante Legal é de preenchimento obrigatório.'
    },

    tipoResponsabilidadeRepresentanteLegal: {
      required: 'O Campo do Tipo de Responsabilidade do Representante Legal é de preenchimento obrigatório.'
    },

    emailOpcionalRepresentanteLegal: {
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal': {
      required: 'O Campo E-mail Principal do Representante Legal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal': {
      required: 'O Campo Confirmar E-mail Principal do Representante Legal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
  };

  // Variáveis de controle dos Checkboxies
  isChecked: boolean = false;
  isCheckedTelefone: boolean = false;
  isCheckedMesmoMail: boolean = false;

  constructor(
    private readonly consumidorService: ConsumidorService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly ngbModalService: NgbModal,
    private readonly enderecoService: EnderecoService,
    private readonly loadingService: LoadingService,
    private readonly tipoResponsabilidadeRepresentanteLegalService: TipoResponsabilidadeRepresentanteLegalService,
    private readonly LinkResourcesServices: LinkResourcesService,
    private readonly consumidorReceitaFederalService: ConsumidorReceitaFederalService
  ) {
    this.contador = 0;
  }

  private RealizaApresentacaoRepresentante() {

    // Verificação da regra de negócio para exibir o formulário de Representante Legal
    // O Formulário só será exibido caso o Consumidor possua idade menor do que 12 anos.
    if (this.showRepresentanteLegal) {

      this.consumidorForm.controls['nomeRepresentanteLegal']
      .setValidators([Validators.required, BlankValidator.valid.bind(this)]);

      if(this.consumidor.situacaoCadastroConsumidorId == 2){
        this.consumidorForm.controls['nomeMaeRepresentanteLegal']
      .setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      }

      this.consumidorForm.controls['cpfRepresentanteLegal'].setValidators([Validators.required, CPFValidator.validaCPF.bind(this), this.cpfRepresentanteLegalMatchValidator.bind(this)]);

      this.consumidorForm.controls['dataNascimentoRepresentanteLegal'].setValidators([Validators.required, DateValidator.validatorBirthDate.bind(this), this.menorIdadeValidator.bind(this)]);
      this.consumidorForm.controls['tipoResponsabilidadeRepresentanteLegal'].setValidators([Validators.required]);
      this.consumidorForm.controls['cidadeRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.consumidorForm.controls['sigUnidFederacaoRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.consumidorForm.controls['logradouroRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.consumidorForm.controls['numeroEnderecoRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.consumidorForm.controls['dddTelefoneRepresentanteLegal'].setValidators([Validators.required]);

      this.consumidorForm.controls['telefoneRepresentanteLegal'].setValidators([Validators.required,Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/),BlankValidator.valid.bind(this)]);

      this.consumidorForm.controls['celularRepresentanteLegal'].setValidators([Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/)]);

      this.consumidorForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValidators([Validators.required, EmailValidator.valid.bind(this)]);
      this.consumidorForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValidators([Validators.required, EmailValidator.valid.bind(this)]);

      this.consumidorForm.controls['cepRepresentanteLegal']
        .setValidators([Validators.required,
                        BlankValidator.valid.bind(this),
                        this.cepTamanhoValidator.bind(this)]);

      this.validaCepRepresentanteLegalExiste.bind(this);

      this.consumidorForm.controls['cepRepresentanteLegal']
        .updateValueAndValidity();

   } else {
      this.showRepresentanteLegal = false;
   }
  }

  private InicializaForm() {

   let formControlFraseSeguranca = new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]);

    // 2 - gov.br
    if(this.consumidor.codOrigemCadastro == 2){
      formControlFraseSeguranca = new FormControl('', [BlankValidator.valid.bind(this)]);
    }

    this.consumidorForm = new FormGroup({
      nome: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      cpf: new FormControl('', [Validators.required, CPFValidator.validaCPF.bind(this)]),
      dataNascimento: new FormControl('', [Validators.required, DateValidator.validatorBirthDate.bind(this)]),
      nomeMae: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      cep: new FormControl(
        '',
        [Validators.required, BlankValidator.valid.bind(this), this.cepTamanhoValidator.bind(this)],
        [this.validaCepExiste.bind(this)]
      ),
      cidade: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      sigUnidFederacao: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      logradouro: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      bairro: new FormControl(''),
      complementoEndereco: new FormControl(''),
      dddTelefone: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      telefone: new FormControl('', [
        BlankValidator.valid.bind(this),
        Validators.required,
        Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/)
      ]),
      dddCelular: new FormControl(''),
      celular: new FormControl('', Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/)),
      emailGroup: new FormGroup(
        {
          emailPrincipal: new FormControl('', [Validators.required, EmailValidator.valid.bind(this)]),
          confirmEmailPrincipal: new FormControl('', [Validators.required, EmailValidator.valid.bind(this)])
        },
        this.emailMatchValidator
      ),
      emailOpcional: new FormControl('', EmailValidator.valid.bind(this)),

      fraseSeguranca: formControlFraseSeguranca,

      situacaoAutorizaNotificacao: new FormControl(''),
      numeroEndereco:new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),

      // Representante Legal

      nomeRepresentanteLegal: new FormControl(''),
      nomeMaeRepresentanteLegal: new FormControl(''),
      cpfRepresentanteLegal: new FormControl(''),
      dataNascimentoRepresentanteLegal: new FormControl(''),
      tipoResponsabilidadeRepresentanteLegal:  new FormControl(''),

      stsUtilizarMesmoEndereco: new FormControl(''),
      stsUtilizarMesmoTelefone: new FormControl(''),
      stsUtilizarMesmoEmail: new FormControl(''),

      cepRepresentanteLegal: new FormControl(''),
      cidadeRepresentanteLegal: new FormControl(''),
      sigUnidFederacaoRepresentanteLegal: new FormControl(''),
      logradouroRepresentanteLegal: new FormControl(''),
      bairroRepresentanteLegal: new FormControl(''),
      complementoEnderecoRepresentanteLegal: new FormControl(''),
      numeroEnderecoRepresentanteLegal:  new FormControl(''),
      dddTelefoneRepresentanteLegal: new FormControl(''),
      telefoneRepresentanteLegal: new FormControl(''),
      dddCelularRepresentanteLegal: new FormControl(''),
      celularRepresentanteLegal: new FormControl(''),

      emailGroupRepresentanteLegal: new FormGroup(
        {
        emailPrincipalRepresentanteLegal: new FormControl(''),
        confirmEmailPrincipalRepresentanteLegal: new FormControl('')
        },
        this.emailRepresentanteLegalMatchValidator
      )

      // Fim Representante Legal
    });
  }

  private DeterminarApresentacaoRepresentante() : void {

    // Caso o Consumidor seja menor de 12 anos, o formulário de Representante legal deve ser exibido.
    // Só será exibido o form de Representante Legal para os Consumidores que aceitaram o termo LGPD.
    if ((this.consumidor.aceitaTermosLGPD != null) && (moment().diff(this.consumidor.dataNascimento, 'years') < 12)) {
      this.showRepresentanteLegal = true;

    // Caso o consumidor não possua representante legal,
    // criar o representante vazio
    if (this.consumidor.representanteLegal == null) {
      this.consumidor.representanteLegal = new RepresentanteLegalModel();
    }

    }else{
      this.consumidor.representanteLegal == null;
    }

  }

  private DefinirSubscriptions() {

    // OBSERVER DE  ALTERAÇÕES NOS VALORES DO CONSUMIDOR
    this.subsConsumidor = this.consumidorService.consumidorChange.subscribe(consumidor => {
      this.consumidor = consumidor;
      this.setFormConsumidor(consumidor);
      this.router.navigate(['consumidor/detalhar']);
    });

    // OBSERVER DE  POSSÍVEIS ERROS NAS REQUISIÇÕES HTTP
    this.subsError = this.consumidorService.consumidorError.subscribe(error => {
      console.log(error);
    });

    // OBSERVER DOS VALIDADORES DO FORMULÁRIO
    this.consumidorForm.valueChanges.subscribe(data => {
      this.onValueChanged(data);
    });

    this.subsCep = this.consumidorForm.get('cep').valueChanges.subscribe(cep => {
      this.cepCleanValidator(cep);
    });

    this.tiposResponsabilidadesRepresentanteLegal = [];
    this.tipoResponsabilidadeRepresentanteLegalChange = this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(data => {
      this.tiposResponsabilidadesRepresentanteLegal = data;
    });

    this.subsCepRepresentanteLegal = this.consumidorForm.get('cepRepresentanteLegal').valueChanges.subscribe(cep => {
      this.cepCleanValidatorRepresentanteLegal(cep);
    });

  }

  ngOnInit() {

    this.consumidor = this.consumidorService.getConsumidorModel();

    this.InicializaForm();

    this.DeterminarApresentacaoRepresentante();

    this.setFormConsumidor(this.consumidor);

    this.RealizaApresentacaoRepresentante();

    this.DefinirSubscriptions();

    this.preencherCombos();

    this.validaCamposSituacaoConsumidor();

    this.validaInformacoesRepresentanteLegal();
  }

  preencherCombos() {

    this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(
      (responsabilidades: TipoResponsabilidadeRepresentanteLegalModel[]) => {
        this.tiposResponsabilidadesRepresentanteLegal = responsabilidades;
      }
    );

    this.tipoResponsabilidadeRepresentanteLegalService.getTiposResponsabilidadesRepresentanteLegal();

        // Inicio o observador que monitora mudança na lista de areas participacoes
        this.unsubTiposResponsabilidadesRepresentanteLegalChange = this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(
          (tiposResponsabilidadesRepresentanteLegal: TipoResponsabilidadeRepresentanteLegalModel[]) => {
            try {
              this.tiposResponsabilidadesRepresentanteLegal = tiposResponsabilidadesRepresentanteLegal;

            } catch (error) {
              console.log('============ unsubTiposResponsabilidadesRepresentanteLegalChange : ' + error);
            }
          }
        );

        this.tipoResponsabilidadeRepresentanteLegalService.getTiposResponsabilidadesRepresentanteLegal();
  }

  validaCepExiste(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    let cep: string = control.value.toString() || '';

    cep = cep.replace(/\.|\-|\_/g, '');

    let cpfFormatado = ConsumidorFormatter.formataString(cep);

    this.contador = this.contador + 1;

    const q = new Promise<IValidation>((resolve, reject) => {
      if (cep && cep.length === 8) {
        this.enderecoService.getEnderecoPeloCep(cpfFormatado).subscribe(
          data => {
            if (this.consumidorForm.controls['cep'].dirty) {
              this.consumidorForm.patchValue({
                sigUnidFederacao: data.estado,
                cidade: data.cidade,
                logradouro: data.logradouro,
                bairro: data.bairro,
                complemento: data.complemento,
                codigoMunicipioIBGE: data.codigoMunicipioIBGE
              });

              // Caso o checkbox de 'Mesmo Endereço" esteja clicado, atualizar os dados do Representante Legal.
              const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
              if (stsUtilizarMesmoEndereco) {
                this.consumidorForm.patchValue({
                  sigUnidFederacaoRepresentanteLegal: data.estado,
                  cidadeRepresentanteLegal: data.cidade,
                  logradouroRepresentanteLegal: data.logradouro,
                  bairroRepresentanteLegal: data.bairro,
                  complementoRepresentanteLegal: data.complemento,
                  codigoMunicipioIBGERepresentanteLegal: data.codigoMunicipioIBGE
                });
              }

            } else {
              this.consumidorForm.patchValue({
                sigUnidFederacao: data.estado,
                cidade: data.cidade
              });
            }

            this.consumidor.codigoMunicipioIBGE = data.codigoMunicipioIBGE;

            resolve(null);
          },
          error => {
            if (cep) {
              this.formErrors['cep'] = [];
              this.formErrors['cep'].push(this.validationMessages.cep.pattern);
              resolve({ pattern: true });
            } else {
              resolve(null);
            }
          }
        );
      } else {
        resolve(null);
      }
    });

    return q;
  }


  changeDddCelular(value: string): void {

    const stsUtilizarMesmoTelefone = this.consumidorForm.value['stsUtilizarMesmoTelefone'];

    if (stsUtilizarMesmoTelefone) {
      this.consumidorForm.get('dddCelularRepresentanteLegal').setValue(value);
    }
  }

  changeCelular(value: string): void {

    const stsUtilizarMesmoTelefone = this.consumidorForm.value['stsUtilizarMesmoTelefone'];

    if (stsUtilizarMesmoTelefone) {
      this.consumidorForm.get('celularRepresentanteLegal').setValue(value);
    }
  }

  validaCepRepresentanteLegalExiste(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {

    let cep: string = control.value.toString() || '';

    cep = cep.replace(/\.|\-|\_/g, '');

    const q = new Promise<IValidation>((resolve, reject) => {

      if (cep && cep.length === 8) {

        this.enderecoService.getEnderecoPeloCep(cep).subscribe(
          data => {

            if (this.consumidorForm.controls['cepRepresentanteLegal'].dirty) {

                this.consumidorForm.patchValue({
                  sigUnidFederacaoRepresentanteLegal: data.estado,
                  cidadeRepresentanteLegal: data.cidade,
                  logradouroRepresentanteLegal: data.logradouro,
                  bairroRepresentanteLegal: data.bairro,
                  complementoRepresentanteLegal: data.complemento,
                  codigoMunicipioIBGERepresentanteLegal: data.codigoMunicipioIBGE
                });

            } else {
              this.consumidorForm.patchValue({
                sigUnidFederacaoRepresentanteLegal: data.estado,
                cidadeRepresentanteLegal: data.cidade
              });

            }

            this.consumidor.representanteLegal.codigoMunicipioIBGERepresentante = data.codigoMunicipioIBGE;

            resolve(null);
          },
          error => {
            if (cep) {
              this.formErrors['cepRepresentanteLegal'] = [];
              this.formErrors['cepRepresentanteLegal'].push(this.validationMessages.cepRepresentanteLegal.pattern);
              resolve({ pattern: true });
            } else {
              resolve(null);
            }
          }
        );

      } else {
        resolve(null);
      }
    });
    return q;
  }

  ngOnDestroy() {
    this.subsConsumidor.unsubscribe();
    this.subsError.unsubscribe();
    this.subsCep.unsubscribe();
  }

  cepTamanhoValidator(form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const cep: string = form.value.toString();
      if (cep.search('_') !== -1) {
        return { pattern: true };
      }
    }

    return null;
  }

  menorIdadeValidator(form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const data: any = form.value.toString();

      if (moment(data, "DD/MM/YYYY", true).isValid()) {
        if (moment().diff(data, 'years') < 18) {
          return { menorDeIdade: true };
        }
      }
    }

    return null;
  }

  cpfRepresentanteLegalMatchValidator (form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const cpfRepresentante: number = ConsumidorFormatter.formataNumero(form.value.toString());
      const cpfConsumidor: number = ConsumidorFormatter.formataNumero(this.consumidorForm.value['cpf']);
      if (cpfRepresentante == cpfConsumidor) {
        return { mesmoCpfConsumidor: true };
      }
    }

    return null;
  }

  private cepCleanValidator(cep) {
    if (!cep) {
      this.consumidorForm.patchValue({
        cidade: '',
        sigUnidFederacao: '',
        logradouro: '',
        bairro: '',
        complementoEndereco: ''
      });
    }
    return null;
  }

  private cepCleanValidatorRepresentanteLegal(cep) {
    if (!cep) {
      this.consumidorForm.patchValue({
        cidadeRepresentanteLegal: '',
        sigUnidFederacaoRepresentanteLegal: '',
        logradouroRepresentanteLegal: '',
        bairroRepresentanteLegal: '',
        complementoEnderecoRepresentanteLegal: ''
      });
    }
    return null;
  }

  private emailMatchValidator(g: FormGroup) {
    if (!g.get('emailPrincipal').valid || !g.get('confirmEmailPrincipal').valid) {
      return null;
    }

    if (!g.get('emailPrincipal').value && !g.get('confirmEmailPrincipal').value) {
      return null;
    }

    return g.get('emailPrincipal').value === g.get('confirmEmailPrincipal').value ? null : { emailNaoConfirmado: true };
  }


  private emailRepresentanteLegalMatchValidator(g: FormGroup) {

    if (!g.get('emailPrincipalRepresentanteLegal').valid || !g.get('confirmEmailPrincipalRepresentanteLegal').valid) {
      return null;
    }

    if (!g.get('emailPrincipalRepresentanteLegal').value && !g.get('confirmEmailPrincipalRepresentanteLegal').value) {
      return null;
    }

    return g.get('emailPrincipalRepresentanteLegal').value === g.get('confirmEmailPrincipalRepresentanteLegal').value ? null : { emailNaoConfirmado: true };
  }


  dddEmbbedValidator(controlDDD: AbstractControl, controlCelular: AbstractControl): boolean {

    const undef = undefined;
    const dddCelular = controlDDD.value;
    const celular = controlCelular.value;

    const formGroup = controlDDD.parent.controls;
    const name = Object.keys(formGroup).find(name => controlDDD === formGroup[name]) || null;

    if (name == 'dddCelularRepresentanteLegal') {

      if (dddCelular !== null && dddCelular !== undef && dddCelular !== '') {

      if (!this.consumidorForm.getRawValue().celularRepresentanteLegal) {

          this.formErrors.celularRepresentanteLegal.push(this.validationMessages.celularRepresentanteLegal.celularObrigatorio);
          return false;
        } else {
          this.formErrors.celularRepresentanteLegal = [];
        }
      } else {
        this.formErrors.celularRepresentanteLegal = [];
      }

      if (celular !== null && celular !== undef && celular !== '') {

      if (!this.consumidorForm.getRawValue().dddCelularRepresentanteLegal) {

          this.formErrors.celularRepresentanteLegal.push(this.validationMessages.celularRepresentanteLegal.dddCelularObrigatorio);
          return false;
        } else {
          this.formErrors.celularRepresentanteLegal = [];
        }
      } else {
        this.formErrors.celularRepresentanteLegal = [];
      }

    } else {

      if (dddCelular !== null && dddCelular !== undef && dddCelular !== '') {

            if (!this.consumidorForm.getRawValue().celular) {

              this.formErrors.celular.push(this.validationMessages.celular.celularObrigatorio);
              return false;
            } else {
              this.formErrors.celular = [];
            }
          } else {
            this.formErrors.celular = [];
          }

          if (celular !== null && celular !== undef && celular !== '') {

              if (!this.consumidorForm.getRawValue().dddCelular) {

              this.formErrors.celular.push(this.validationMessages.celular.dddCelularObrigatorio);
              return false;
            } else {
              this.formErrors.celular = [];
            }
          } else {
            this.formErrors.celular = [];
          }
    }
    return true;
  }


  public onModalBuscaCEP(): void {
    const modal: NgbModalRef = this.ngbModalService.open(NgbdModalContent, { size: 'lg' });

    this.subscriptionEnderecoModelSelecionado = modal.componentInstance.enderecoModelSelecionado.subscribe((endereco: EnderecoModel) => {
      this.consumidorForm.patchValue({
        cep: endereco.cep,
        cidade: endereco.cidade,
        sigUnidFederacao: endereco.estado,
        logradouro: endereco.logradouro,
        bairro: endereco.bairro,
        complemento: endereco.complemento
      });
      this.consumidor.codigoMunicipioIBGE = endereco.codigoMunicipioIBGE;
    });
  }

  private setFormConsumidor(consumidor: ConsumidorModel) {

    if (!this.consumidor.situacaoAutorizaNotificacao || this.consumidor.situacaoAutorizaNotificacao === undefined) {
      this.consumidor.situacaoAutorizaNotificacao = 0;
    }

    let mesmoEndereco  = false;
    let mesmoEmail  = false;
    let mesmoTelefone  = false;

    // Caso o Consumidor possua representante Legal, veriifcar se o endereço e e-mail são iguais.
    if (this.consumidor.representanteLegal && this.consumidor.representanteLegal.cpfRepresentante) {

        mesmoEndereco = this.verificaMesmoEndereco(this.consumidor.representanteLegal);

        mesmoEmail = this.verificaMesmoEmail(this.consumidor.representanteLegal);

        mesmoTelefone = this.verificaMesmoTelefone(this.consumidor.representanteLegal);
    }

    this.consumidorForm.setValue({
      nome: this.consumidor.nome,
      cpf: `${UtilHelper.lpad(this.consumidor.cpfBase.toString(), 9)}${UtilHelper.lpad(this.consumidor.cpfDigito.toString(), 2)}`,
      dataNascimento: ConsumidorFormatter.date2StrDate(this.consumidor.dataNascimento),
      nomeMae: this.consumidor.nomeMae,
      cep: this.consumidor.cep,
      cidade: '',
      sigUnidFederacao: '',
      logradouro: consumidor.logradouro,
      bairro: this.consumidor.bairro,
      complementoEndereco: this.consumidor.complementoEndereco,
      dddTelefone: this.consumidor.dddTelefone,
      telefone: MaskManager.telMask(this.consumidor.telefone),
      dddCelular: this.consumidor.dddCelular,
      celular: MaskManager.telMask(this.consumidor.celular),
      emailGroup: {
        emailPrincipal: this.consumidor.emailPrincipal,
        confirmEmailPrincipal: this.consumidor.emailPrincipal
      },
      emailOpcional: this.consumidor.emailOpcional,
      fraseSeguranca: this.consumidor.fraseSeguranca,
      situacaoAutorizaNotificacao: this.consumidor.situacaoAutorizaNotificacao,
      numeroEndereco: this.consumidor.numeroEndereco,

      stsUtilizarMesmoEndereco: mesmoEndereco,
      stsUtilizarMesmoEmail: mesmoEmail,
      stsUtilizarMesmoTelefone: mesmoTelefone,

      cidadeRepresentanteLegal: '',
      sigUnidFederacaoRepresentanteLegal: '',
      nomeRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.nomeRepresentante == null)?'':this.consumidor.representanteLegal.nomeRepresentante,
      nomeMaeRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.nomeMaeRepresentante == null)? '': (this.consumidor.situacaoCadastroConsumidorId == 1? '': this.consumidor.representanteLegal.nomeMaeRepresentante),
      cpfRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.cpfRepresentante == null)?'':this.consumidor.representanteLegal.cpfRepresentante ,
      dataNascimentoRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.dataNascimentoRepresentante == null)?'':ConsumidorFormatter.date2StrDate(this.consumidor.representanteLegal.dataNascimentoRepresentante),
      tipoResponsabilidadeRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.dataNascimentoRepresentante == null)?'':this.consumidor.representanteLegal.codTipoResponsabilidadeRepresentante,
      cepRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.cepRepresentante == null)?'':this.consumidor.representanteLegal.cepRepresentante,
      logradouroRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.logradouroRepresentante == null)?'':this.consumidor.representanteLegal.logradouroRepresentante,
      bairroRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.bairroRepresentante == null)?'':this.consumidor.representanteLegal.bairroRepresentante,
      complementoEnderecoRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.complementoEnderecoRepresentante == null)?'':this.consumidor.representanteLegal.complementoEnderecoRepresentante,
      numeroEnderecoRepresentanteLegal:  (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.numeroEnderecoRepresentante == null)?'':this.consumidor.representanteLegal.numeroEnderecoRepresentante,
      dddTelefoneRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.dddTelefoneRepresentante == null)?'':this.consumidor.representanteLegal.dddTelefoneRepresentante,
      telefoneRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.telefoneRepresentante == null)?'':MaskManager.telMask(this.consumidor.representanteLegal.telefoneRepresentante),
      dddCelularRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.dddCelularRepresentante == null)?'':this.consumidor.representanteLegal.dddCelularRepresentante,
      celularRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.celularRepresentante == null)?'':MaskManager.telMask(this.consumidor.representanteLegal.celularRepresentante),
      emailGroupRepresentanteLegal: {
        emailPrincipalRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.emailPrincipalRepresentante == null)?'':this.consumidor.representanteLegal.emailPrincipalRepresentante,
        confirmEmailPrincipalRepresentanteLegal: (this.consumidor.representanteLegal == null || this.consumidor.representanteLegal.emailPrincipalRepresentante == null)?'':this.consumidor.representanteLegal.emailPrincipalRepresentante
      }

    });

    this.isCheckedMesmoMail = mesmoEmail;
    this.emailGroupRepresentanteLegalDisable(mesmoEmail);

    this.isChecked = mesmoEndereco;
    this.enderecoGRoupRepresentanteLegalDisable(mesmoEndereco);

    this.isCheckedTelefone = mesmoTelefone;
    this.telefoneGroupRepresentanteLegalDisable(mesmoTelefone);

    this.validaCepExiste(this.consumidorForm.controls['cep']);

    if(this.consumidor.representanteLegal != null) {
      this.validaCepRepresentanteLegalExiste(this.consumidorForm.controls['cepRepresentanteLegal']);
    }
  }

  verificaMesmoEmail(representante: RepresentanteLegalModel): boolean  {

    if (representante != null) {

      if (representante.emailPrincipalRepresentante) {
        if (this.consumidor.emailPrincipal != representante.emailPrincipalRepresentante.trim()) {
          return false;
        }
      }
    }  else {
      return false;
    }

    return true;
  }

  verificaMesmoTelefone(representante: RepresentanteLegalModel): boolean  {

    if (representante != null) {

      if (representante.dddTelefoneRepresentante) {
        if (this.consumidor.dddTelefone != Number(representante.dddTelefoneRepresentante)) {
          return false;
        }
      }

      if (representante.telefoneRepresentante) {
        if (this.consumidor.telefone != Number(representante.telefoneRepresentante)) {
          return false;
        }
      }

      if (representante.dddCelularRepresentante) {
        if (this.consumidor.dddCelular != Number(representante.dddCelularRepresentante)) {
          return false;
        }
      }

      if (representante.celularRepresentante) {
        if (this.consumidor.celular != Number(representante.celularRepresentante)) {
          return false;
        }
      }

    }  else {
      return false;
    }

    return true;
  }

  verificaMesmoEndereco(representante: RepresentanteLegalModel): boolean  {

    if (representante != null) {

      if (this.consumidor.representanteLegal.cepRepresentante && this.consumidor.cep) {

        if (this.consumidor.cep != representante.cepRepresentante) {
          return false;
        }
      }

      if (representante.codigoMunicipioIBGERepresentante && this.consumidor.codigoMunicipioIBGE) {

        if (this.consumidor.codigoMunicipioIBGE != Number(representante.codigoMunicipioIBGERepresentante)) {
          return false;
        }
      }

      if (representante.complementoEnderecoRepresentante && this.consumidor.complementoEndereco) {

          if (this.consumidor.complementoEndereco.trim() != representante.complementoEnderecoRepresentante.trim()) {
            return false;
          }
       }

      if (representante.bairroRepresentante && this.consumidor.bairro) {

          if (this.consumidor.bairro.trim() != representante.bairroRepresentante.trim()) {
            return false;
          }
      }

      if (representante.logradouroRepresentante && this.consumidor.logradouro) {

          if (this.consumidor.logradouro.trim() != representante.logradouroRepresentante.trim()) {
            return false;
          }
      }

      if (representante.numeroEnderecoRepresentante && this.consumidor.numeroEndereco) {

          if (this.consumidor.numeroEndereco.trim() != representante.numeroEnderecoRepresentante.trim()) {
            return false;
          }
      }

   }else {
    return false;
   }

   return true;

  }

  validaForm(): boolean {
    let valid = true;
    this.formErrors.errosSelecao = [];
    for (const campo in this.formErrors) {
      const control = this.consumidorForm.get(campo);
      this.formErrors[campo] = [];

      if (control && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          valid = false;
          this.formErrors[campo].push(messages[key]);
        }
      }
    }

    if (!this.dddEmbbedValidator(this.consumidorForm.controls['dddCelular'],this.consumidorForm.controls['celular'])) {
      valid = false;
    }

    if (this.showRepresentanteLegal) {
      if (!this.dddEmbbedValidator(this.consumidorForm.controls['dddCelularRepresentanteLegal'],this.consumidorForm.controls['celularRepresentanteLegal'])) {
        valid = false;
      }
    }

    return valid;
  }

  onSubmit() {

    if (this.validaForm()) {

      const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });

      confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja alterar seus dados?';
      const unsubConfirm = confirmModal.componentInstance.userConfirmChange.subscribe(userConfirm => {

        if (userConfirm) {

          this.loadingService.exibirLoading('Aguarde enquanto suas alterações estão sendo salvas.');

          // Compõe o objeto a ser persistido.
          this.addConsumidor();

          this.consumidorService.atualizarConsumidor(this.consumidor).subscribe(
            {
                next: (data) => {

                    const confirmModal = this.ngbModalService.open(NbpInfoComponent);

                    confirmModal.componentInstance.info = 'Alteração realizada com sucesso.';

                    this.consumidorService.setConsumidorModel(this.consumidor);

                      this.router.navigate(['consumidor/detalhar']);

                },
                error: (err) =>{

                    this.loadingService.esconderLoading();

                    // Apresenta a mensagem de erro para o usuário.
                    let erro = err as StatusRequisicao;
                    this.msgErro = erro.motivo;

                    // Move a tela para cima, para que os erros venham a ser apresentados so usuário.
                    AnimacaoHelper.ScrollUpTela(100);
                },
                complete: () => {
                    this.loadingService.esconderLoading();
                }
            }
        );
          unsubConfirm.unsubscribe();
        }
      });
    }
  }

  // Metodo para testar a inclusao de um consumidor
  addConsumidor(): void {
    this.consumidor.nome = this.consumidorForm.get('nome').value;
    this.consumidor.cpf = ConsumidorFormatter.formataString(this.consumidorForm.value['cpf']);
    this.consumidor.dataNascimento = ConsumidorFormatter.strDate2Date(this.consumidorForm.value['dataNascimento']);
    this.consumidor.nomeMae = this.consumidorForm.get('nomeMae').value;
    this.consumidor.cep = ConsumidorFormatter.formataString(this.consumidorForm.value['cep']);
    this.consumidor.logradouro = this.consumidorForm.value['logradouro'];
    this.consumidor.numeroEndereco = this.consumidorForm.value['numeroEndereco'];
    this.consumidor.bairro = this.consumidorForm.value['bairro'];
    this.consumidor.complementoEndereco = this.consumidorForm.value['complementoEndereco'];
    this.consumidor.dddTelefone = ConsumidorFormatter.formataNumero(this.consumidorForm.value['dddTelefone']);
    this.consumidor.telefone = ConsumidorFormatter.formataNumero(this.consumidorForm.value['telefone']);
    this.consumidor.dddCelular = ConsumidorFormatter.formataNumero(this.consumidorForm.value['dddCelular']);
    this.consumidor.celular = ConsumidorFormatter.formataNumero(this.consumidorForm.value['celular']);
    this.consumidor.emailPrincipal = this.consumidorForm.get('emailGroup').value['emailPrincipal'];
    this.consumidor.emailOpcional = this.consumidorForm.value['emailOpcional'];
    this.consumidor.fraseSeguranca = this.consumidorForm.value['fraseSeguranca'];
    this.consumidor.stsAutorizaNotificacao = ConsumidorFormatter.formatStsCheckValue(
      this.consumidorForm.value['situacaoAutorizaNotificacao']
    );
    this.consumidor.instituicoes = [];

    if (this.showRepresentanteLegal) {
      // Campos Representante Legal:

      this.consumidor.representanteLegal.nomeRepresentante = ConsumidorFormatter.formataString(this.consumidorForm.value['nomeRepresentanteLegal']);

      let nomeMaeRepresentante = this.consumidorForm.value['nomeMaeRepresentanteLegal'];

      if(nomeMaeRepresentante){
        this.consumidor.representanteLegal.nomeMaeRepresentante = ConsumidorFormatter.formataString(nomeMaeRepresentante).toUpperCase();
      }

      this.consumidor.representanteLegal.cpfRepresentante = ConsumidorFormatter.formataString(this.consumidorForm.value['cpfRepresentanteLegal']);
      this.consumidor.representanteLegal.dataNascimentoRepresentante = ConsumidorFormatter.strDate2Date(this.consumidorForm.value['dataNascimentoRepresentanteLegal']);
      this.consumidor.representanteLegal.codTipoResponsabilidadeRepresentante = this.consumidorForm.value['tipoResponsabilidadeRepresentanteLegal'];
      this.consumidor.representanteLegal.logradouroRepresentante = this.consumidorForm.get('logradouroRepresentanteLegal').value;

      this.consumidor.representanteLegal.numeroEnderecoRepresentante = this.consumidorForm.get('numeroEnderecoRepresentanteLegal').value;

      this.consumidor.representanteLegal.complementoEnderecoRepresentante = this.consumidorForm.getRawValue().complementoEnderecoRepresentanteLegal;

      this.consumidor.representanteLegal.bairroRepresentante = this.consumidorForm.getRawValue().bairroRepresentanteLegal;
      this.consumidor.representanteLegal.cepRepresentante = ConsumidorFormatter.formataString(this.consumidorForm.get('cepRepresentanteLegal').value);

      this.consumidor.representanteLegal.dddTelefoneRepresentante = ConsumidorFormatter.formataNumero(this.consumidorForm.getRawValue().dddTelefoneRepresentanteLegal);
      this.consumidor.representanteLegal.telefoneRepresentante = ConsumidorFormatter.formataNumero(this.consumidorForm.getRawValue().telefoneRepresentanteLegal);

      this.consumidor.representanteLegal.dddCelularRepresentante = ConsumidorFormatter.formataNumero(this.consumidorForm.getRawValue().dddCelularRepresentanteLegal);
      this.consumidor.representanteLegal.celularRepresentante = ConsumidorFormatter.formataNumero(this.consumidorForm.getRawValue().celularRepresentanteLegal);

      this.consumidor.representanteLegal.emailPrincipalRepresentante = this.consumidorForm.get('emailGroupRepresentanteLegal').value['emailPrincipalRepresentanteLegal'];
      this.consumidor.representanteLegal.emailPrincipalRepresentante = this.consumidorForm.get('emailGroupRepresentanteLegal').value['confirmEmailPrincipalRepresentanteLegal']

      // Fim Campos Representante Legal
    } else {
      this.consumidor.representanteLegal = null;
    }
  }

  cancelaCadastro() {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja cancelar a alteração do cadastro?';

    const unsubConfirm = confirmModal.componentInstance.userConfirmChange.subscribe(userConfirm => {
      if (userConfirm) {
        this.router.navigate(['consumidor/detalhar']);
        unsubConfirm.unsubscribe();
      }
    });
  }

  onValueChanged(data?: any) {
    for (const campo in this.formErrors) {
      const control = this.consumidorForm.get(campo);
      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          this.formErrors[campo].push(messages[key]);
        }
      }
    }
  }


  changeCEP(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('cepRepresentanteLegal').setValue(value);
    }
  }

  changeCidade(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('cidadeRepresentanteLegal').setValue(value);
    }
  }

  changeUF(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('sigUnidFederacaoRepresentanteLegal').setValue(value);
    }
  }

  changeLogradouro(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('logradouroRepresentanteLegal').setValue(value);
    }
  }

  changeBairro(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('bairroRepresentanteLegal').setValue(value);
    }
  }

  changeComplementoEndereco(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('complementoEnderecoRepresentanteLegal').setValue(value);
    }
  }

  changeTelefone(value: string): void {
    const stsUtilizarMesmoTelefone = this.consumidorForm.value['stsUtilizarMesmoTelefone'];
    if (stsUtilizarMesmoTelefone) {
      this.consumidorForm.get('telefoneRepresentanteLegal').setValue(value);
    }
  }

  changeDddTelefone(value: string): void {
    const stsUtilizarMesmoTelefone = this.consumidorForm.value['stsUtilizarMesmoTelefone'];
    if (stsUtilizarMesmoTelefone) {
      this.consumidorForm.get('dddTelefoneRepresentanteLegal').setValue(value);
    }
  }

  changeNumeroEndereco(value: string): void {
    const stsUtilizarMesmoEndereco = this.consumidorForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.consumidorForm.get('numeroEnderecoRepresentanteLegal').setValue(value);
    }
  }
  changeEmailPrincipal(value: string): void {
    const stsUtilizarMesmoEmail = this.consumidorForm.value['stsUtilizarMesmoEmail'];
    if (stsUtilizarMesmoEmail) {
      this.consumidorForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValue(value);
      this.consumidorForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValue(value);
    }
  }

  checkUtilizarMesmoEndereco(event: any) {

    if (event == 'S') {

      this.consumidorForm.get('cepRepresentanteLegal').setValue(this.consumidorForm.get('cep').value);
      this.consumidorForm.get('cidadeRepresentanteLegal').setValue(this.consumidorForm.get('cidade').value);
      this.consumidorForm.get('sigUnidFederacaoRepresentanteLegal').setValue(this.consumidorForm.get('sigUnidFederacao').value);
      this.consumidorForm.get('logradouroRepresentanteLegal').setValue(this.consumidorForm.get('logradouro').value);
      this.consumidorForm.get('bairroRepresentanteLegal').setValue(this.consumidorForm.get('bairro').value);
      this.consumidorForm.get('complementoEnderecoRepresentanteLegal').setValue(this.consumidorForm.get('complementoEndereco').value);
      this.consumidorForm.get('numeroEnderecoRepresentanteLegal').setValue(this.consumidorForm.get('numeroEndereco').value);

      this.consumidor.representanteLegal.codigoMunicipioIBGERepresentante = this.consumidor.codigoMunicipioIBGE;

      this.enderecoGRoupRepresentanteLegalDisable(true);

    } else {

      this.enderecoGRoupRepresentanteLegalDisable(false);
    }
  }

  enderecoGRoupRepresentanteLegalDisable(value: boolean) {

    if (value) {

      this.consumidorForm.get('cepRepresentanteLegal').disable();
      this.consumidorForm.get('cidadeRepresentanteLegal').disable();
      this.consumidorForm.get('sigUnidFederacaoRepresentanteLegal').disable();
      this.consumidorForm.get('logradouroRepresentanteLegal').disable();
      this.consumidorForm.get('bairroRepresentanteLegal').disable();
      this.consumidorForm.get('complementoEnderecoRepresentanteLegal').disable();
      this.consumidorForm.get('numeroEnderecoRepresentanteLegal').disable();

    } else {
      this.consumidorForm.get('cepRepresentanteLegal').enable();
      this.consumidorForm.get('cidadeRepresentanteLegal').enable();
      this.consumidorForm.get('sigUnidFederacaoRepresentanteLegal').enable();
      this.consumidorForm.get('logradouroRepresentanteLegal').enable();
      this.consumidorForm.get('bairroRepresentanteLegal').enable();
      this.consumidorForm.get('complementoEnderecoRepresentanteLegal').enable();
      this.consumidorForm.get('numeroEnderecoRepresentanteLegal').enable();
    }
  }

  checkUtilizarMesmoTelefone(event: any) {

    if (event == 'S') {

      this.consumidorForm.get('dddTelefoneRepresentanteLegal').setValue(this.consumidorForm.get('dddTelefone').value);
      this.consumidorForm.get('telefoneRepresentanteLegal').setValue(this.consumidorForm.get('telefone').value);

      this.consumidorForm.get('dddCelularRepresentanteLegal').setValue(this.consumidorForm.get('dddCelular').value);
      this.consumidorForm.get('celularRepresentanteLegal').setValue(this.consumidorForm.get('celular').value);

      this.telefoneGroupRepresentanteLegalDisable(true);

    } else {

      this.telefoneGroupRepresentanteLegalDisable(false);
    }
  }

  telefoneGroupRepresentanteLegalDisable(value: boolean) {

    if (value) {

      this.consumidorForm.get('dddTelefoneRepresentanteLegal').disable();
      this.consumidorForm.get('telefoneRepresentanteLegal').disable();

      this.consumidorForm.get('dddCelularRepresentanteLegal').disable();
      this.consumidorForm.get('celularRepresentanteLegal').disable();

    } else {

      this.consumidorForm.get('dddTelefoneRepresentanteLegal').enable();
      this.consumidorForm.get('telefoneRepresentanteLegal').enable();

      this.consumidorForm.get('dddCelularRepresentanteLegal').enable();
      this.consumidorForm.get('celularRepresentanteLegal').enable();
    }
  }

  checkUtilizarMesmoEmail(event: any){
    if (event == 'S') {
      this.consumidorForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValue(this.consumidorForm.get('emailGroup.emailPrincipal').value);
      this.consumidorForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValue(this.consumidorForm.get('emailGroup.emailPrincipal').value);

      this.emailGroupRepresentanteLegalDisable(true);

    } else {
      this.emailGroupRepresentanteLegalDisable(false);
    }
 }

 emailGroupRepresentanteLegalDisable(value: boolean) {

  if (value) {
    this.consumidorForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').disable();
    this.consumidorForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').disable();
  } else {
    this.consumidorForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').enable();
    this.consumidorForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').enable();
  }
 }

 onBuscaCEPRepresentanteLegal() {

  let cep: string = this.consumidorForm.value['cepRepresentanteLegal'] || '';

  cep = cep.replace(/\.|\-|\_/g, '');

  if (cep && cep.length === 8) {
    const s: Subscription = this.enderecoService.getEnderecoPeloCep(cep).subscribe(
      (data: EnderecoModel) => {
        this.consumidorForm.patchValue({
          sigUnidFederacaoRepresentanteLegal: data.estado,
          cidadeRepresentanteLegal: data.cidade,
          logradouroRepresentanteLegal: data.logradouro,
          bairroRepresentanteLegal: data.bairro,
          complementoRepresentanteLegal: data.complemento,
          codigoMunicipioIBGERepresentanteLegal: data.codigoMunicipioIBGE
        });

        this.consumidor.representanteLegal.codigoMunicipioIBGERepresentante = data.codigoMunicipioIBGE;
        s.unsubscribe();
      },
      erro => {
        this.consumidor.representanteLegal.codigoMunicipioIBGERepresentante = 0;

        // Apresenta a mensagem de erro para o usuário.
        let error = erro as StatusRequisicao;

        this.formErrors['cepRepresentanteLegal'] = [];
        this.formErrors['cepRepresentanteLegal'].push(error.motivo);
      }
    );
  } else {
    if (cep) {
      this.formErrors['cepRepresentanteLegal'] = [];
      this.formErrors['cepRepresentanteLegal'].push(this.validationMessages.cepRepresentanteLegal.pattern);
    }
  }
}

private validaCamposSituacaoConsumidor() {
  if(this.consumidor.situacaoCadastroConsumidorId == 2){
    this.consumidorForm.get('nome').disable();
    this.consumidorForm.get('nomeMae').disable();
  }
}

LimparErros(event) { 
  this.msgErroRepresentanteLegal = "";
}

private validaInformacoesRepresentanteLegal(){

  this.consumidorForm.get('cpfRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
    if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
      this.validaSituacaoRepresentanteLegalReceitaFederal();
  });

  this.consumidorForm.get('dataNascimentoRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
    if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
      this.validaSituacaoRepresentanteLegalReceitaFederal();
  });

  this.consumidorForm.get('nomeMaeRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
    if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
      this.validaSituacaoRepresentanteLegalReceitaFederal();
  });

}

private camposObrigatoriosRepresentanteLegalPreenchidos(){

  let cpfRepresentanteLegal = this.consumidorForm.get('cpfRepresentanteLegal').value;
  let dataNascimentoRepresentanteLegal = this.consumidorForm.get('dataNascimentoRepresentanteLegal').value;
  let nomeMaeRepresentanteLegal = this.consumidorForm.get('nomeMaeRepresentanteLegal').value;

  return ((cpfRepresentanteLegal !== null && cpfRepresentanteLegal !== undefined && cpfRepresentanteLegal !== '') &&
      (dataNascimentoRepresentanteLegal !== null && dataNascimentoRepresentanteLegal !== undefined && dataNascimentoRepresentanteLegal !== '') &&
      (nomeMaeRepresentanteLegal !== null && nomeMaeRepresentanteLegal !== undefined && nomeMaeRepresentanteLegal !== '') &&
      this.consumidor.situacaoCadastroConsumidorId == 2);
}

private validaSituacaoRepresentanteLegalReceitaFederal() {

  let cpf = ConsumidorFormatter.formataString(this.consumidorForm.get('cpfRepresentanteLegal').value);

  if(cpf != this.consumidor.cpf) {
    var filtro = new FiltroConsumidorReceitaFederal(cpf, 
                                                  ConsumidorFormatter.strDateWithoutHourAndSlash(this.consumidorForm.get('dataNascimentoRepresentanteLegal').value),
                                                  this.consumidorForm.get('nomeMaeRepresentanteLegal').value);

    this.consumidorReceitaFederalService.validaSituacaoConsumidorReceitaFederal(filtro).subscribe((data) => {
      // preencher o nome do representante legal e deixar o campo desabilitado
      this.consumidorForm.get('nomeRepresentanteLegal').setValue(data.nomeCidadao);

      // limpar mensagem de erro
      if (this.msgErroRepresentanteLegal)
          this.msgErroRepresentanteLegal = '';
    },
    (error: any) => {
      let err = error as StatusRequisicao; 
      this.msgErroRepresentanteLegal = err.motivo;
      this.consumidorForm.get('nomeRepresentanteLegal').reset();
    });
  } else {
    if (this.msgErroRepresentanteLegal)
        this.msgErroRepresentanteLegal = '';
  }
}

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-edit/consumidor-edit.component.ts